module.exports = __webpack_public_path__ + "img/corridoio 3.4a32a6b0.jpeg";